import { Skeleton } from "@mui/material";
import styles from "./list.module.css";

/**
 * Skeleton loader for the User Permissions matrix. Mirrors the sticky
 * name column + role columns so nothing jumps around once real data
 * arrives.
 */
const UserPermissionsLoader = ({ rows = 8, roleCols = 4 }) => {
    const rowArray = Array.from({ length: rows });
    const colArray = Array.from({ length: roleCols });

    return (<div aria-busy="true" aria-label="Loading permissions">
        <div className={`${styles.PermTableWrap}`}>
            <table className={`${styles.PermTable}`}>
                <tbody>
                    <tr className={`${styles.PermRoleHeadRow}`}>
                        <th className={`${styles.PermNameCell}`}><Skeleton variant="text" width={60} /></th>
                        {colArray.map((_, i) => (
                            <th key={i}><Skeleton variant="text" width={90} /></th>
                        ))}
                    </tr>
                    {rowArray.map((_, rowIdx) => (
                        <tr key={rowIdx} className={rowIdx % 3 === 0 ? styles.PermCategoryRow : styles.PermChildRow}>
                            <td className={`${styles.PermNameCell}`}>
                                <Skeleton variant="text" width={rowIdx % 3 === 0 ? 140 : 180} style={{ marginLeft: rowIdx % 3 === 0 ? 0 : 20 }} />
                            </td>
                            {colArray.map((_, colIdx) => (
                                <td key={colIdx} className={`${styles.PermCheckboxCell}`}>
                                    <Skeleton variant="rounded" width={20} height={20} style={{ margin: "0 auto", borderRadius: 4 }} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>);
};

export default UserPermissionsLoader;